var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowRight12X21 = function SvgArrowRight12X21(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "main-color-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 20.554
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.505 20.049a1.714 1.714 0 0 1 0-2.431l7.36-7.342-7.36-7.342A1.719 1.719 0 0 1 2.936.503l8.56 8.553a1.708 1.708 0 0 1 0 2.429l-8.56 8.562a1.714 1.714 0 0 1-2.431 0Z"
  })));
};
export default SvgArrowRight12X21;